/**
 * Constants for JSExecutor configuration
 */
export const EXECUTION_CONSTANTS = {
  defaultTimeout: 60 * 60 * 1000,
  defaultFunctionName: 'main',
  maxOutputLength: 500,
  denoCommand: 'deno',
  denoFlags: [ 'run', '--unstable-detect-cjs', '--quiet', '--unstable-sloppy-imports' ],
  processSignals: {
    term: 'SIGTERM'
  }
} as const;

/**
 * Default execution options
 */
export const DEFAULT_EXECUTION_OPTIONS = {
  timeout: EXECUTION_CONSTANTS.defaultTimeout,
  functionName: EXECUTION_CONSTANTS.defaultFunctionName,
  allowNetwork: false,
  allowedDomains: [],
  allowEnv: true,
  allowRead: false,
  debugMode: false,
  retries: 0
} as const;
